import React from 'react';
import { Form, Input } from 'antd';
import RichEditor from '@modules/questionnaires/complexity/richEditor';

function EditLeadingPracticeList({ form, formListName }) {
  return (
    <Form form={form} autoComplete="off">
      <Form.List name={formListName}>
        {(fields, { add, remove }) =>
          fields.map(({ key, name, ...restField }, index) => (
            <div className="competency-edit-item" key={key}>
              <div className="competency-edit-item-header">
                <Form.Item
                  name={[name, 'title']}
                  rules={[
                    {
                      required: true,
                      message: 'Please input title!',
                    },
                  ]}
                >
                  <Input
                    className="competency-edit-item-title"
                    maxLength={60}
                  />
                </Form.Item>
              </div>
              <Form.Item
                name={[name, 'content']}
                className="competency-edit-item-editor"
              >
                <RichEditor
                  linkPopoverProps={{
                    placement: 'leftTop',
                  }}
                />
              </Form.Item>
            </div>
          ))
        }
      </Form.List>
    </Form>
  );
}

export default EditLeadingPracticeList;
